module.exports = __webpack_public_path__ + "static/media/the_diamond.7148af6d.jpg";